import { render } from "./GetPw.vue?vue&type=template&id=10a6e4ac&scoped=true"
import script from "./GetPw.vue?vue&type=script&lang=js"
export * from "./GetPw.vue?vue&type=script&lang=js"

import "./GetPw.vue?vue&type=style&index=0&id=10a6e4ac&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a6e4ac"]])

export default __exports__